import { render, staticRenderFns } from "./AddressSelector.vue?vue&type=template&id=20eb8f06&scoped=true"
import script from "./AddressSelector.vue?vue&type=script&lang=js"
export * from "./AddressSelector.vue?vue&type=script&lang=js"
import style0 from "./AddressSelector.vue?vue&type=style&index=0&id=20eb8f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb8f06",
  null
  
)

export default component.exports